import { useTheme as useThemeBase } from '@rneui/themed';
export const useTheme = () => {
    const { theme } = useThemeBase();
    return theme || {};
};
//# sourceMappingURL=useTheme.js.map